import { AeroDataChannel } from "./AeroDataChannel";
import { EDS300Flag, EDS300Sot } from "./EDS300";
import { AeroDataFileElement, EDS300FileElement, FligthInspectionFileElement, WietzeToolFileElement } from "./FileElement";
import { FligthInspectionConfigAbstract } from "./FligthInspectionConfigAbstract";

// CSV Configuration
export class FligthInspectionConfig extends FligthInspectionConfigAbstract{
    fileFormatElements: FligthInspectionFileElement[];
	currentChannel: string;
	altitudeUnits: string ="";
}

// EDS300 Configuration
export class EDS300Config extends FligthInspectionConfigAbstract{
    altitudeUnits: string = ""; 

	recordedPowerDensityKey: string;
	currentChannel: string;
	sots: EDS300Sot[];
	flags: EDS300Flag[];
	fileFormatElements: EDS300FileElement[];
	mdmeChannel: number;
	isSoTsEnabled: boolean;
	isFlagsEnabled: boolean;
}

// Aero Data Configuration
export class AeroDataConfigProcessingTool extends FligthInspectionConfigAbstract{
    channels: AeroDataChannel[] = [];
	fileFormatElements: AeroDataFileElement[];
	currentChannel: string;
}

// Processing Tool Output data flags default configuration
export class WietzeToolConfig {
    fileFormatElements: WietzeToolFileElement[];
	static readonly DEFAULT_FORMAT: string = "wietzetoolconfig";
}

